import { render, staticRenderFns } from "./DocLink.vue?vue&type=template&id=49393f41&"
import script from "./DocLink.vue?vue&type=script&lang=js&"
export * from "./DocLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports